import formQuery from './formQuery';
import { DocumentNode } from 'graphql';

export const defaultTempRecord = (query: DocumentNode, duplicate: boolean) => {
  return formQuery(query, true, duplicate, 'uuid');
};

const defaultRecord = (
  query: DocumentNode,
  duplicate?: boolean,
  idParam: string = 'id',
  idParamValueFn?: (_: any | null) => string
) => {
  return formQuery(query, true, duplicate, idParam, idParamValueFn);
};

export default defaultRecord;
